export function formatBudgetValue(value: string | number | null | undefined) {
	if (value == null || value === "") return "";

	const sanitized = String(value).replace(/[^\d.]/g, "");
	if (!sanitized) return "";

	const firstDecimalIndex = sanitized.indexOf(".");
	const normalizedValue =
		firstDecimalIndex === -1
			? sanitized
			: `${sanitized.slice(0, firstDecimalIndex + 1)}${sanitized.slice(firstDecimalIndex + 1).replace(/\./g, "")}`;

	const [rawIntegerPart, rawFractionalPart] = normalizedValue.split(".", 2);
	const integerPart = (rawIntegerPart || "").replace(/^0+(?=\d)/, "") || "0";
	const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

	if (rawFractionalPart === undefined) {
		return formattedIntegerPart;
	}

	return `${formattedIntegerPart}.${rawFractionalPart.slice(0, 2)}`;
}

export default formatBudgetValue;
